<template>
	<div class="type">
		<div class="title">{{title}}</div>
		<vSelect v-bind="{items: selectItems, activeType, name}" v-model="selected" @input="select" @activeType="$emit('activeType', $event)"/>
	</div>
</template>

<script>
import {orderBy} from 'lodash';
import vSelect from "./select/index.vue";

export default {
	components: {vSelect},
	props: {
		activeType: {type: String, required: true},
		endpoint: {type: String, required: true},
		title: {type: String, required: true},
		name: {type: String, required: true}
	},
	data() {
		return {
			items: [],
			selected: this.$route.query[this.name] ? this.$route.query[this.name].split(",").map(x => Number(x)) : []
		}
	},
	computed: {
		selectItems() {
			const items = this.items.map(x => ({
				label: x.name,
				value: x.id
			}));
			return orderBy(items, 'label', 'asc');
		}
	},	
	methods: {
		select(items) {
			this.$emit("update", {[this.name]: items.length ? items.join(",") : undefined});
		},
		async getItems() {
			const {data: {data}} = await this.$axios.get(this.endpoint, {params: {count: 1000}});
			this.items = data;
		}
	},
	created() {
		this.getItems();
	}
};
</script>

<style lang="scss" scoped>
.type {
	margin-top: 2em;
	.title {
		font-weight: 300;
		margin-bottom: 10px;
	}
}
</style>
